import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { BaseService } from '../base/base.service';


@Injectable({
  providedIn: 'root'
})
export class APIService extends BaseService {

  public id: string = "";
  public baseUrl: String = "";


  constructor(http: HttpClient) {
    super(http);

  }


  public loginUser(data) 
  {
    return this.saveData("user/login", data).pipe(map((res:any) => {
      this.id = res.SessionId;
      return res;
    }));
  }

  public logoutUser(data) 
  {
    return this.saveData("user/logout", data);
  }

  public getAssetTypeDetails(data)
  {
    return this.saveData("asset/type/details", data);
  }

  public getJobDetails(data)
  {
    return this.saveData("job/details", data);
  }

  public getEmployeeDetails(data)
  {
    return this.saveData("user/details", data);
  }

  public getClientDetailsOnLogin(data)
  {
    return this.saveData("client/details", data);
  }

  public createNewAssetType(data) 
  {
    return this.saveData("asset/type/create", data);
  }

  public createNewJob(data) 
  {
    return this.saveData("job/create", data);
  }

  public updateJob(data) 
  {
    return this.saveData("job/update", data);
  }

  public addAssetToJob(data) 
  {
    return this.saveData("job/asset/add", data);
  }
  
  public addJobHistoryLog(data) 
  {
    return this.saveData("history/job/add", data);
  }

  public addAssetHistoryLog(data) 
  {
    return this.saveData("history/asset/add", data);
  }

  public addUserHistoryLog(data) 
  {
    return this.saveData("history/user/add", data);
  }

  public addLocationHistoryLog(data) 
  {
    return this.saveData("history/location/add", data);
  }

  public addClientHistoryLog(data) 
  {
    return this.saveData("history/client/add", data);
  }

  public addVehicleHistoryLog(data) 
  {
    return this.saveData("history/vehicle/add", data);
  }

  public removeAssetFromJob(data) 
  {
    return this.saveData("job/asset/remove", data);
  }

  public deleteJobFile(data) 
  {
    return this.saveData("job/file/delete", data);
  }

  public deleteJob(data) 
  {
    return this.saveData("job/delete", data);
  }

  public printJob(data)
  {
    return this.saveData("job/print", data);
  }

  public generateJobSurveyQuote(data)
  {
    return this.saveData("job/survey/quote", data);
  }

  public createNewAssetGroup(data)
  {
    return this.saveData("asset/group/create", data);
  }

  public createNewJobStatus(data)
  {
    return this.saveData("job/status", data);
  }

  public deleteJobStatus(data)
  {
    return this.saveData("job/status/delete", data);
  }

  public deleteAssetGroup(data)
  {
    return this.saveData("asset/group/delete", data);
  }

  public getAllAssetTypesInAssetGroup(data)
  {
    return this.saveData("asset/type/find", data);
  }

  public updateAssetType(data)
  {
    return this.saveData("asset/type/update", data);
  }

  public createNewAssetTypePreset(data)
  {
    return this.saveData("asset/type/preset", data);
  }

  public createNewAssetTypeStlPreset(data)
  {
    return this.saveData("asset/type/preset/stl", data);
  }
  
  public updateAssetTypePreset(data)
  {
    return this.saveData("asset/type/updatepreset", data);
  }

  public getAddressesFromPostCode(postCode, organisationUid)
  {
    var payload = {
      postCode: postCode,
      organisationUid: organisationUid
    };

    return this.saveData("address/find", payload);
  }

  public getJobLocationGeo(data)
  {
    return this.saveData("location/job/geo", data);
  }

  public createNewLocation(data)
  {
    return this.saveData("location/create", data);
  }

  public deleteLocation(data)
  {
    return this.saveData("location/delete", data);
  }

  public deleteAssetType(data)
  {
    return this.saveData("asset/type/delete", data);
  }

  public deleteAssetTypePreset(data)
  {
    return this.saveData("asset/type/deletepreset", data);
  }

  public deleteAssetTypeStlPreset(data)
  {
    return this.saveData("asset/type/deletepreset/stl", data);
  }
  
  public changeClient(data)
  {
    return this.saveData("client/change", data);
  }

  public changeOrganisation(data)
  {
    return this.saveData("client/changeorg", data);
  }

  public deleteUser(data)
  {
    return this.saveData("user/delete", data);
  }
  
  public getOrganisationDetails(data)
  {
    return this.saveData("organisation/details", data);
  }

  public addDefaultAssetTypeToOrganisation(data)
  {
    return this.saveData("organisation/assettype/add", data);
  }

  public removeDefaultAssetTypeFromOrganisation(data)
  {
    return this.saveData("organisation/assettype/remove", data);
  }

  public createOrganisation(data)
  {
    return this.saveData("organisation/create", data);
  }

  public deleteOrganisation(data)
  {
    return this.saveData("organisation/delete", data);
  }

  public createUser(data)
  {
    return this.saveData("user/create", data);
  }

  public createHeicCertificate(data)
  {
    return this.saveData("cert/create", data);
  }

  public downloadHeicCertificate(data)
  {
    return this.saveData("cert/download", data);
  }

  public addAssignableAssetToJob(data)
  {
    return this.saveData("assignable/add", data);
  }

  public removeAssignableAssetFromJob(data)
  {
    return this.saveData("assignable/delete", data);
  }

  public updateUser(data)
  {
    return this.saveData("user/update", data);
  }

  public editUserProfile(data)
  {
    return this.saveData("user/edit", data);
  }

  public getClientProfile(data)
  {
    return this.saveData("client/profile", data);
  }

  public getClientBadgeCount(data)
  {
    return this.saveData("client/badge", data);
  }

  public updateClient(data)
  {
    return this.saveData("client/update", data);
  }

  public sendPasswordResetEmail(data)
  {
    return this.saveData("user/reset", data);
  }

  public changePasswordUsingEmailCode(data)
  {
    return this.saveData("user/change", data);
  }

  public userChangedPassword(data)
  {
    return this.saveData("user/pass", data);
  }

  public deleteUserFile(data) 
  {
    return this.saveData("user/file/delete", data);
  }

  public downloadUserFile(data) 
  {
    return this.saveData("user/file/download", data);
  }

  public getAssetImage(data)
  {
    //"s3Path", "assetUid", "clientUid"
    return this.saveData("asset/image/get", data);
  }

  public getAssetReportImage(data)
  {
    //"s3Path", "assetUid", "clientUid"
    return this.saveData("report/image/get", data);
  }

  public placeNewAssetOnMap(payload) 
  {
    return this.saveData("app/cat/asset/place", payload);
  }

  public moveAssetOnMap(payload) 
  {
    return this.saveData("app/cat/asset/move", payload);
  }

  public getAssetDetails(payload) 
  {
    return this.saveData("asset/details", payload);
  }

  public deleteAsset(payload) 
  {
    return this.saveData("asset/delete", payload);
  }

  public getLocationDetails(payload) 
  {
    return this.saveData("location/details", payload);
  }
  
  public updateAsset(payload)
  {
    return this.saveData("asset/update", payload);
  }

  public updateLocationDetails(payload) 
  {
    return this.saveData("location/update", payload);
  }

  public updateJobAssetDetails(payload)
  {
    return this.saveData("job/asset/update", payload);
  }

  public getJobAssetImage(payload)
  {
    return this.saveData("job/asset/image", payload);
  }

  public getDesignerSignature(payload)
  {
    return this.saveData("signature/designer", payload);
  }

  public getInstallerSignature(payload)
  {
    return this.saveData("signature/installer", payload);
  }

  public getManagerSignature(payload)
  {
    return this.saveData("signature/manager", payload);
  }

  public uploadSignature(payload)
  {
    return this.saveData("signature/upload", payload);
  }

  public createAssetConditionReport(payload)
  {
    return this.saveData("asset/condition/create", payload);
  }

  public updateAssetConditionReport(payload)
  {
    return this.saveData("asset/condition/update", payload);
  }

  public exportAssetConditionReportByLocation(payload)
  {
    var headers = new HttpHeaders().set('id', this.id);

    return this.http.post(`${this.baseUrl}${"asset/condition/export"}`, JSON.stringify(payload), {headers, responseType: 'arraybuffer'})
    .pipe(map(res => res))
  }

  public uploadAssetImage(payload, url)
  {
    return this.saveData(url, payload);
  }

  public uploadReportImage(payload, url)
  {
    return this.saveData(url, payload);
  }

  public deleteAssetPhoto(payload)
  {
    return this.saveData("asset/image/delete", payload);
  }

  public deleteAssetReportPhoto(payload)
  {
    return this.saveData("report/image/delete", payload);
  }

  public addObservationToAsset(payload)
  {
    return this.saveData("observation/add", payload);
  }

  public getSingleObservation(payload)
  {
    return this.saveData("observation/get", payload);
  }
  
  public updateObservation(payload)
  {
    return this.saveData("observation/update", payload);
  }

  public removeRemedialStlFromObservation(payload)
  {
    return this.saveData("observation/remove", payload);
  }

  public addCustomRemedialStlToObservation(payload)
  {
    return this.saveData("observation/remedial/custom/add", payload);
  }

  public removeCustomRemedialStlFromObservation(payload)
  {
    return this.saveData("observation/remedial/custom/remove", payload);
  }

  public deleteObservationFromAsset(payload)
  {
    return this.saveData("observation/delete", payload);
  }

  public createAlert(payload)
  {
    return this.saveData("alert/create", payload);
  }

  public getAlerts(payload)
  {
    return this.saveData("alert/all", payload);
  }

  public deleteRemedialFromJobAsset(payload)
  {
    return this.saveData("job/asset/delrem", payload);
  }

  public deleteAssetConditionReport(payload)
  {
    return this.saveData("asset/condition/delete", payload);
  }

  public getConditionReportDetails(payload)
  {
    return this.saveData("asset/condition/details", payload);
  }

  public deletePowerAlertForLocation(payload)
  {
    return this.saveData("alert/power", payload);
  }

  public deleteAlert(payload)
  {
    return this.saveData("alert/delete", payload);
  }

  public markObservationAsRepaired(payload)
  {
    return this.saveData("observation/repaired", payload);
  }

  public removeRepairFromObservation(payload)
  {
    return this.saveData("observation/unrepair", payload);
  }

  public addRecommendationToObservation(payload)
  {
    return this.saveData("observation/recommend", payload);
  }

  public removeRecommendationToObservation(payload)
  {
    return this.saveData("observation/unrecommend", payload);
  }

  public updateJobRiskForm(payload)
  {
    return this.saveData("risk/update", payload);
  }

  public getReportData(payload)
  {
    return this.saveData("reports/data", payload);
  }

  public setupReport(payload)
  {
    return this.saveData("reports/setup", payload);
  }

  public getReportHeaders(payload)
  {
    return this.saveData("reports/headers", payload);
  }

  public updateReport(payload)
  {
    return this.saveData("reports/update", payload);
  }

  public createReport(payload)
  {
    return this.saveData("reports/create", payload);
  }

  public downloadReport(payload)
  {
    return this.saveData("reports/download", payload);
  }

  public deleteReport(payload)
  {
    return this.saveData("reports/delete", payload);
  }

  public getStlPresetsForReport(payload)
  {
    return this.saveData("reports/filter/stlpreset", payload);
  }

  public getListOfUsers(payload)
  {
    return this.saveData("list/users", payload);
  }

  public getListOfAssetTypes(payload)
  {
    return this.saveData("list/assettypes", payload);
  }

  public removeAssetPowerIssue(payload)
  {
    return this.saveData("asset/powerrestored", payload);
  }
  
  public exportMultipleLocationsDetailsToExcel(payload)
  {
    return this.saveData("excel/locations", payload);
  }

  public exportLocationDetailsToExcel(payload)
  {
    return this.saveData("excel/location", payload);
  }

  public exportJobDetailsToExcel(payload)
  {
    return this.saveData("excel/job", payload);
  }
  
  public deleteLocationFile(data) 
  {
    return this.saveData("location/file/delete", data);
  }

  public downloadLocationFile(data) 
  {
    return this.saveData("location/file/download", data);
  }

  public addPowerIssueToObservation(data)
  {
    return this.saveData("observation/power/issue", data);
  }

  public removePowerIssueFromObservation(data)
  {
    return this.saveData("observation/power/remove", data);
  }

  public addEngineerToJob(data)
  {
    return this.saveData("job/assignment/engineer/add", data);
  }

  public removeEngineerFromJob(data)
  {
    return this.saveData("job/assignment/engineer/remove", data);
  }

  public createJobCompletedFile(data)
  {
    return this.saveData("job/file/completed", data);
  }

  public exportMasterRoadlist(data) 
  {
    return this.saveData("excel/roadlist", data);
  }

  public getEngineerStatistics(data) 
  {
    return this.saveData("engineer/stats", data);
  }
  
  public createNewStockOrder(data)
  {
    return this.saveData("stock/request", data);
  }

  public deleteStockOrder(data)
  {
    return this.saveData("stock/delete", data);
  }

  public createNewStockItem(data)
  {
    return this.saveData("stock/inventory/add", data);
  }

  public deleteStockItem(data)
  {
    return this.saveData("stock/inventory/delete", data);
  }

  public getDeviceDetails(payload) 
  {
    return this.saveData("device/details", payload);
  }
  
  public deleteDevice(payload) 
  {
    return this.saveData("device/delete", payload);
  }

  public getStockOrderDetails(payload) 
  {
    return this.saveData("stock/details", payload);
  }

  public markStockOrderAsPurchased(payload) 
  {
    return this.saveData("stock/purchased", payload);
  }

  public markStockOrderAsShipped(payload) 
  {
    return this.saveData("stock/shipped", payload);
  }

  public generateCondemnationCert(payload) 
  {
    return this.saveData("cert/condemnation", payload);
  }

  public changeNameOnObservation(payload)
  {
    return this.saveData("observation/name/change", payload);
  }

  public getEngineerSimpleStatistics(payload)
  {
    return this.saveData("engineer/simple", payload);
  }

  public getEngineerStatisticsRepairList(payload)
  {
    return this.saveData("engineer/repairs", payload);
  }

  public getEngineerStatisticsRecommendedList(payload)
  {
    return this.saveData("engineer/recommendations", payload);
  }

  public getStockPresetDetails(payload)
  {
    return this.saveData("stock/preset/details", payload);
  }

  public createNewStockPreset(payload)
  {
    return this.saveData("stock/preset/create", payload);
  }
  
  public updateStockPresetStock(payload)
  {
    return this.saveData("stock/preset/stock/update", payload);
  }

  public updateStockPresetAssetType(payload)
  {
    return this.saveData("stock/preset/assettype/update", payload);
  }

  public updateStockPresetRemedial(payload)
  {
    return this.saveData("stock/preset/remedial/update", payload);
  }

  public addVehicle(payload)
  {
    return this.saveData("vehicle/add", payload);
  }

  public getVehicleDetails(payload)
  {
    return this.saveData("vehicle/details", payload);
  }

  public updateVehicle(payload)
  {
    return this.saveData("vehicle/update", payload);
  }

  public deleteVehicle(payload)
  {
    return this.saveData("vehicle/delete", payload);
  }

  public assignEngineerToVehicle(payload)
  {
    return this.saveData("vehicle/engineer/assign", payload);
  }

  public removeEngineerFromVehicle(payload)
  {
    return this.saveData("vehicle/engineer/remove", payload);
  }

  public submitNewVehicleReport(data)
  {
    return this.saveData("vehicle/report/create", data);
  }

  public deleteVehicleReport(data)
  {
    return this.saveData("vehicle/report/delete", data);
  }
  
}
